import { render, staticRenderFns } from "./ListFolderIcon.vue?vue&type=template&id=172a568c&"
import script from "./ListFolderIcon.vue?vue&type=script&lang=js&"
export * from "./ListFolderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports